import { render, staticRenderFns } from "./LessonExperiment.vue?vue&type=template&id=23051f91"
import script from "./LessonExperiment.vue?vue&type=script&lang=js"
export * from "./LessonExperiment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports